export default __webpack_public_path__ + "static/media/community.3216d8cb.svg";